import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ContentService, environment, HelperService, UserService } from "@mypxplat/xplat/core";

import { CourseDetailBaseComponent } from "@mypxplat/xplat/features";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-course-detail",
  templateUrl: "course-detail.component.html",
  standalone: false,
})
export class CourseDetailComponent extends CourseDetailBaseComponent implements OnInit {
  constructor(
    userService: UserService,
    public activatedRoute: ActivatedRoute,
    public contentService: ContentService,
    public helperService: HelperService,
    public appService: AppService,
    private _router: Router
  ) {
    super(userService);
  }

  ngOnInit() {
    this.contentService.getEducationData().subscribe((result) => {
      this.courseId = this.activatedRoute.snapshot.params["id"];
      this.course = this.contentService.courseMap[this.courseId];
    });
  }

  pin(enroll = true) {
    let args: any = {
      user_id: this.user.id,
      learn_group_id: this.course.id,
      enrolled: enroll,
      date_started: new Date(),
    };

    this.contentService.saveUserLearnGroupData(this.course.id, args).subscribe({
      next: (result) => {},
      error: (error) => {
        this.appService.alertError(error);
      },
    });
  }

  upgrade() {
    this._router.navigate(["/onboarding"], { queryParams: { subscribeOnly: true } });
  }
}
